import React from 'react'
import { Box, Container, Typography, Divider, Link as MuiLink, List, ListItem, ListItemText } from '@mui/material'
import { useTranslation } from 'react-i18next'

const Datenschutz: React.FC = () => {
  const { i18n } = useTranslation()
  const isDe = (i18n.resolvedLanguage || i18n.language || 'de').startsWith('de')

  return (
    <Container sx={{ maxWidth: 900, mx: 'auto' }}>
      {isDe ? (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h3" gutterBottom>Datenschutzerklärung</Typography>
            <Typography color="text.secondary">Informationen nach Art. 13, 14 DSGVO</Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Verantwortlicher</Typography>
            <Typography>
              {/* Bitte mit echten Daten ersetzen */}
              Name/Firma<br/>
              Straße Hausnummer<br/>
              PLZ Ort, Deutschland<br/>
              E‑Mail: <MuiLink href="mailto:kontakt@example.com">kontakt@example.com</MuiLink>
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Zugriffsdaten/Server‑Logs</Typography>
            <Typography color="text.secondary">
              Beim Aufruf dieser Website erheben wir bzw. unser Hosting‑Provider automatisch Server‑Logs (z. B. IP‑Adresse, Datum/Uhrzeit,
              angeforderte Ressource, Referrer, User‑Agent). Die Verarbeitung erfolgt zur Sicherstellung eines störungsfreien Betriebs
              (berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO). Die Daten werden in der Regel nach kurzer Zeit gelöscht bzw. anonymisiert.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Cookies</Typography>
            <Typography color="text.secondary">
              Diese Website verwendet nur technisch notwendige Cookies, soweit dies für den Betrieb erforderlich ist. Es findet kein Tracking zu
              Marketing‑Zwecken statt. Rechtsgrundlage ist unser berechtigtes Interesse am funktionsfähigen Betrieb der Website (Art. 6 Abs. 1 lit. f DSGVO).
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Kontakt</Typography>
            <Typography color="text.secondary">
              Wenn Sie uns per E‑Mail kontaktieren, verarbeiten wir Ihre Angaben zur Bearbeitung der Anfrage (Art. 6 Abs. 1 lit. b oder f DSGVO).
              Die Angaben können zur Dokumentation gespeichert werden und werden gelöscht, sobald die Speicherung nicht mehr erforderlich ist.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Empfänger der Daten</Typography>
            <Typography color="text.secondary">
              Dienstleister, die wir zur Bereitstellung der Website einsetzen (z. B. Hosting), verarbeiten Daten im Auftrag auf Grundlage von
              Auftragsverarbeitungsverträgen (Art. 28 DSGVO).
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Ihre Rechte</Typography>
            <Typography color="text.secondary" sx={{ mb: 1 }}>
              Sie haben gegenüber dem Verantwortlichen folgende Rechte:
            </Typography>
            <List dense>
              <ListItem><ListItemText primary="Auskunft (Art. 15 DSGVO)" /></ListItem>
              <ListItem><ListItemText primary="Berichtigung (Art. 16 DSGVO)" /></ListItem>
              <ListItem><ListItemText primary="Löschung (Art. 17 DSGVO)" /></ListItem>
              <ListItem><ListItemText primary="Einschränkung der Verarbeitung (Art. 18 DSGVO)" /></ListItem>
              <ListItem><ListItemText primary="Datenübertragbarkeit (Art. 20 DSGVO)" /></ListItem>
              <ListItem><ListItemText primary="Widerspruch (Art. 21 DSGVO)" /></ListItem>
              <ListItem><ListItemText primary="Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)" /></ListItem>
            </List>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Speicherdauer</Typography>
            <Typography color="text.secondary">
              Personenbezogene Daten werden nur so lange gespeichert, wie es für die jeweiligen Zwecke erforderlich ist oder gesetzliche
              Aufbewahrungspflichten bestehen.
            </Typography>
          </Box>

          <Box sx={{ mt: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Hinweis: Passen Sie diese Datenschutzerklärung an Ihre tatsächlichen Prozesse und Dienste an (z. B. eingesetzte Hoster, Analyse‑Dienste,
              CDN, eingebettete Inhalte). Letzte Aktualisierung: {new Date().toISOString().slice(0,10)}
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ mb: 3 }}>
            <Typography variant="h3" gutterBottom>Privacy Policy</Typography>
            <Typography color="text.secondary">Information pursuant to Art. 13, 14 GDPR</Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Controller</Typography>
            <Typography>
              {/* Replace with real details */}
              Name/Company<br/>
              Street No.<br/>
              ZIP City, Germany<br/>
              Email: <MuiLink href="mailto:contact@example.com">contact@example.com</MuiLink>
            </Typography>
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Access data / server logs</Typography>
            <Typography color="text.secondary">
              When you visit this website, we and/or our hosting provider automatically collect server logs (e.g. IP address, date/time, requested resource,
              referrer, user agent). Processing takes place to ensure trouble‑free operation (legitimate interest, Art. 6(1)(f) GDPR). Data is usually deleted
              or anonymized after a short period of time.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Cookies</Typography>
            <Typography color="text.secondary">
              This website only uses technically necessary cookies to the extent required for operation. No marketing tracking takes place. The legal basis is
              our legitimate interest in the functional operation of the website (Art. 6(1)(f) GDPR).
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Contact</Typography>
            <Typography color="text.secondary">
              If you contact us by email, we process your details to handle the request (Art. 6(1)(b) or (f) GDPR). The information may be stored for
              documentation and is deleted as soon as storage is no longer necessary.
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Recipients of personal data</Typography>
            <Typography color="text.secondary">
              Service providers we use to provide the website (e.g. hosting) process data on our behalf on the basis of data processing agreements (Art. 28 GDPR).
            </Typography>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Your rights</Typography>
            <Typography color="text.secondary" sx={{ mb: 1 }}>
              You have the following rights vis‑à‑vis the controller:
            </Typography>
            <List dense>
              <ListItem><ListItemText primary="Access (Art. 15 GDPR)" /></ListItem>
              <ListItem><ListItemText primary="Rectification (Art. 16 GDPR)" /></ListItem>
              <ListItem><ListItemText primary="Erasure (Art. 17 GDPR)" /></ListItem>
              <ListItem><ListItemText primary="Restriction of processing (Art. 18 GDPR)" /></ListItem>
              <ListItem><ListItemText primary="Data portability (Art. 20 GDPR)" /></ListItem>
              <ListItem><ListItemText primary="Object to processing (Art. 21 GDPR)" /></ListItem>
              <ListItem><ListItemText primary="Lodge a complaint with a supervisory authority (Art. 77 GDPR)" /></ListItem>
            </List>
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant="h5" gutterBottom>Retention period</Typography>
            <Typography color="text.secondary">
              Personal data is stored only for as long as necessary for the respective purposes or as required by statutory retention obligations.
            </Typography>
          </Box>

          <Box sx={{ mt: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Note: Adapt this privacy policy to your actual processes and services (e.g. hosting providers, analytics, CDN, embedded content). Last updated:
              {" "}{new Date().toISOString().slice(0,10)}
            </Typography>
          </Box>
        </>
      )}
    </Container>
  )
}

export default Datenschutz
